// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1_Rrf","cls2":"mentions_milestone_ping-cls2_KGJ mentions_milestone_ping-cls1_Rrf"};